import { useState } from "react";
import { isMobile } from "react-device-detect";
import { StickyHeader } from "../../intro/components/landing-new";
import { useTranslation } from "react-i18next";
import { useUserLocale } from "../../customHooks/useUserLocale";
export default function CompanyInformation() {
  const { t } = useTranslation();
  // const { language, community, currency, loading, handleChangeLocale } =
  //   useUserLocale();
  const community = "tw";

  return (
    <div className="tw-relative tw-flex tw-min-h-screen tw-flex-col tw-items-center tw-justify-center tw-overflow-hidden tw-p-4">
      <StickyHeader />

      <div className="tw-relative tw-z-10 tw-w-full tw-max-w-3xl tw-space-y-6 tw-rounded-lg tw-bg-gray-900 tw-bg-opacity-70 tw-p-6 tw-shadow-xl tw-backdrop-blur-md">
        {community == "tw" ? (
          <div className="tw-text-center">
            <h1 className="tw-mb-2 tw-text-xl tw-font-bold tw-text-white">Singapore (Global HQ)</h1>
            <p className="tw-text-lg tw-text-gray-300">Social Travel Pte. Ltd.</p>
          </div>
        ) : (
          <h1 className="tw-text-center tw-text-3xl tw-font-bold tw-text-white">
            Company Information
          </h1>
        )}

        <div className="tw-rounded-lg tw-bg-gray-900 tw-p-4 tw-shadow-md">
          <div className="tw-mb-4">
            <h2 className="tw-text-xl tw-font-semibold tw-text-white">
              {community === "tw" && "Singapore"}
              {community === "sg" && "Singapore"}
              {community === "my" && "Malaysia"}
              {community === "id" && "Indonesia"}
            </h2>
          </div>
          <div className="tw-text-gray-300">
            {/* {community === "tw" && (
              <div className="tw-space-y-6">
                <div className="tw-space-y-2">
                  <h2 className="tw-text-xl tw-font-semibold tw-text-white">
                    星亞旅行社股份有限公司
                  </h2>
                  <ul className="tw-space-y-1">
                    <li>負責人：廖文鈴</li>
                    <li>統一編號：14057566</li>
                    <li>旅行業註冊編號：交觀甲0127號</li>
                    <li>品保協會員編號：品保北0468號</li>
                  </ul>
                </div>

                <div className="tw-pt-4 tw-border-t tw-border-gray-700 tw-space-y-2">
                  <h2 className="tw-text-xl tw-font-semibold tw-text-white">
                    SOTRAVELTW Ltd.
                  </h2>
                  <ul className="tw-space-y-1">
                    <li>負責人：陳冠霖</li>
                    <li>統一編號：60707574</li>
                    <li>聯絡電話：0918292376</li>
                    <li>聯絡郵件：community@sotravel.com</li>
                    <li>聯絡地址：新北市蘆洲區信義路399號3樓</li>
                  </ul>
                </div>
              </div>
            )} */}

            {community === "tw" ? (
              <div>
                <ul className="tw-space-y-1">
                  <li>統一編號: 202346815N</li>
                  <li>旅行社執照: TA03798</li>
                  <li>辦公室地址: 150D East Coast Rd</li>
                </ul>
              </div>
            ) : (
              <div>
                <ul className="tw-space-y-1">
                  <li>UEN: 202346815N</li>
                  <li>TA LICENSE: TA03798</li>
                  <li>OFFICE: 150D East Coast Rd</li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
